export const EVENT_USER_ROLES = {
  owner: 'owner',
  participant: 'participant',
  applicant: 'applicant',
} as const
export type EventUserRole = keyof typeof EVENT_USER_ROLES
